import { createSlice } from '@reduxjs/toolkit';

const LoginSlice = createSlice({
    name: 'LoginSlice',
    initialState: {
        pageRefreshCode: 0 ,
    },
    reducers: {
        updatePageRefreshCode: state => {
            state.pageRefreshCode = Math.random();
        }
	}
})

export const { updatePageRefreshCode} = LoginSlice.actions

export default LoginSlice;